<template>
  <v-col class="pa-0">
    <v-row class="ma-0 pa-0">
      <v-col align="center" cols="8" offset="2">
        <span class="text-h5">{{ $translate('RESET_EMAIL_SENT_TITLE') }}</span>
      </v-col>
      <v-col align="end" cols="2">
        <v-icon size="20" @click="onClose"> ti-close </v-icon>
      </v-col>
    </v-row>
    <v-col align="center" justify="center" class="py-5">
      <v-icon size="140" color="#a7dc86"> mail_outline </v-icon>
    </v-col>
    <v-col class="pa-3">
      <v-alert dense color="blue" text type="info">
        {{ $translate('CHECK_SPAM_REMINDER') }}
      </v-alert>
    </v-col>
    <v-row class="ma-0 pa-0 py-4" justify="center">
      <v-btn color="primary" large @click="onClose">
        {{ $translate('CLOSE') }}
      </v-btn>
    </v-row>
  </v-col>
</template>

<script>
import uiHelpers from '../../shared/ui_helpers';

export default {
  name: 'AccountChangeEmailSuccess',
  mixins: [uiHelpers],
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {
    onClose() {
      this.$router.push({
        name: 'Homepage',
        params: {
          account_id: this.$store.getters.getRegion,
        },
      });
    },
  },
};
</script>
